import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Button, LockIcon, MenuIcon, CrossIcon, Pane, Heading, Avatar, Badge, Link as LinkEv, Image, IconButton } from 'evergreen-ui';
import { useAuth } from '../services/authContext';
import '../styles/public-responsive.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, user } = useAuth();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavigation = (path) => {
        navigate(path);
        setIsMenuOpen(false);
    };

    return (
        <Pane 
            is="nav" 
            display="flex" 
            justifyContent="space-between" 
            alignItems="center" 
            padding={16} 
            background="tint2"
            borderBottom="muted"
            marginBottom={24}
            position="relative"
            zIndex={100}
        >
            <Pane display="flex" alignItems="center" gap={12} cursor="pointer" onClick={() => navigate('/')}>
                <Image src="/logo_gaag.png" alt="Logo GAAG" height={40} borderRadius={4} />
                <Pane display="flex" alignItems="baseline" gap={8} className="header-title">
                    <Heading size={700} color="green" is={Link} to="/" style={{textDecoration: 'none'}}>GAAG CASA LETIZIA</Heading>
                </Pane>
            </Pane>
            
            {/* Hamburger icon for mobile */}
            <Pane display="none" className="mobile-menu-btn">
                <IconButton 
                    icon={isMenuOpen ? CrossIcon : MenuIcon} 
                    appearance="minimal" 
                    onClick={toggleMenu} 
                    height={40}
                />
            </Pane>

            {/* Nav links container - hidden on mobile unless menu is open */}
            <Pane 
                display="flex" 
                gap={24} 
                alignItems="center"
                className={`nav-links-container ${isMenuOpen ? 'mobile-menu-open' : ''}`}
            >
                <LinkEv is={Link} to="/chi-siamo" color="neutral" style={location.pathname === '/chi-siamo' ? { color: '#47B881', fontWeight: 'bold' } : {}} onClick={() => setIsMenuOpen(false)}>Chi siamo</LinkEv>
                <LinkEv is={Link} to="/cosa-facciamo" color="neutral" style={location.pathname === '/cosa-facciamo' ? { color: '#47B881', fontWeight: 'bold' } : {}} onClick={() => setIsMenuOpen(false)}>Cosa facciamo</LinkEv>
                <LinkEv is={Link} to="/la-casa" color="neutral" style={location.pathname === '/la-casa' ? { color: '#47B881', fontWeight: 'bold' } : {}} onClick={() => setIsMenuOpen(false)}>La casa</LinkEv>
                <LinkEv is={Link} to="/il-metodo" color="neutral" style={location.pathname === '/il-metodo' ? { color: '#47B881', fontWeight: 'bold' } : {}} onClick={() => setIsMenuOpen(false)}>Il metodo</LinkEv>
                <LinkEv is={Link} to="/contatti" color="neutral" style={location.pathname === '/contatti' ? { color: '#47B881', fontWeight: 'bold' } : {}} onClick={() => setIsMenuOpen(false)}>Contatti</LinkEv>
                
                {isAuthenticated ? (
                    <Pane display="flex" alignItems="center" className="auth-container">
                        <Avatar 
                            name={user.email} 
                            size={40} 
                            marginRight={16} 
                            cursor="pointer"
                            onClick={() => handleNavigation('/profilo')}
                        />
                        <Badge 
                            color={user.role === 'direttore' ? 'green' : user.role === 'educatore' ? 'blue' : 'red'}
                            onClick={
                                user.role === 'direttore' 
                                    ? () => handleNavigation('/areaDirettore') 
                                    : user.role === 'educatore' 
                                    ? () => handleNavigation('/areaEducatori') 
                                    : () => handleNavigation('/areaOperatori')
                            }
                            cursor="pointer"
                        >
                            {user.role === 'direttore' 
                                ? 'Area direttore' 
                                : user.role === 'educatore' 
                                ? 'Area educatori' 
                                : 'Area operatori'}
                        </Badge>
                    </Pane>
                ) : (
                    <Button 
                        appearance="primary" 
                        intent="success"
                        iconBefore={LockIcon} 
                        onClick={() => handleNavigation('/login')}
                        fontSize={16}
                    >
                        Area riservata
                    </Button>
                )}
            </Pane>
        </Pane>
    );
}

export default Header;